import { query } from '../../network/fetch.js'
import {
    PARAM_LIST,
    SHOW_MENU,
    HIDE_MENU,
    TOGGLE_MENU,
    UPDATE_WEEK
} from '../types'

const queries = {
    getParams: `query getParams {
        schools {
            id
            name
        }
		roles {
			id
			display_name
		}
		statuses {
			id
			name
		}
    }`
}

const state = {
    teams: [],
    schools: [],
    roles: [],
    statuses: [],
    algoliaAppId: 'JH8C2O0QUO',
    showMenu: false,
    week: new Date()
}

const actions = {

    getParams ({ commit }) {
        return new Promise((resolve) => {
            query({
                query: queries.getParams
            }).then( ({ data }) => {
                commit(PARAM_LIST, data)
                resolve()
            })
        })
    },

    updateWeek({ commit }, newWeek) {
        commit(UPDATE_WEEK, newWeek)
    }
}

const mutations = {
    [PARAM_LIST](state, params) {
        state.teams = params.teams
        state.schools = params.schools
        state.roles = params.roles
        state.statuses = params.statuses
    },
    [SHOW_MENU](state) {
        state.showMenu = true
    },
    [HIDE_MENU](state) {
        state.showMenu = false
    },
    [TOGGLE_MENU](state) {
        state.showMenu = state.showMenu ? false : true
    },
    [UPDATE_WEEK](state, newWeek) {
        state.week = newWeek
    }
}

export default {
    state,
    actions,
    mutations
}
